import React from 'react'
import Timings from './TimingSection/Timings'
import QuranAyah from './Ayah/Randomayah'
import NewComponent from './Subcomp/Newcomponent';
import './Subcomp/NewComponent.css'
import DailyReminders from './Reminder/DailyReminders';

export default function Mainpage() {
  return (
    <div>
      <DailyReminders></DailyReminders>
      <Timings></Timings>
      <QuranAyah></QuranAyah>
      <div className='newcomp-container' style={{ textDecoration: 'none' }}>
        <NewComponent title="Holy Quran " content=" Get Holy Quran with English Translation and recitation here" linkTo="/HolyQuran" />
        <NewComponent title="Hadith books Details " content=" Get the list of names and details of the famous and authentic hadith books " linkTo="/Hadith" />
        <NewComponent title="99 Names of Allah" content="Get 99 Names of Allah with their meanings" linkTo='/AllahNames' />
        <NewComponent title="Islamic Lectures" content="Get Islamic lessons through your favourite scholars on major problems" linkTo="/Lectures" />
      </div>
    </div>
  )
}
